import React from 'react';
import PropTypes from 'prop-types';
import cautionIcon from '../../images/caution.svg';
import { StyledFeedbackBanner, Paragraph, Icon } from './styles.js';

export const FeedbackBanner = ({ header, content, error = false }) => {
  return (
    <StyledFeedbackBanner error={error}>
      <Paragraph error={error}>
        {error && <Icon src={cautionIcon} alt="caution sign" />}
        {header && <strong>{header}&nbsp;</strong>}
        {content}
      </Paragraph>
    </StyledFeedbackBanner>
  );
};

FeedbackBanner.displayName = 'FeedbackBanner';

FeedbackBanner.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  error: PropTypes.bool,
};
